import { render, staticRenderFns } from "./VolunteerBackendComponentNav.vue?vue&type=template&id=189cdcca&scoped=true&"
import script from "./VolunteerBackendComponentNav.vue?vue&type=script&lang=js&"
export * from "./VolunteerBackendComponentNav.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerBackendComponentNav.vue?vue&type=style&index=0&id=189cdcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cdcca",
  null
  
)

export default component.exports